import { runClientCallbackSafely } from '../shared/capture-client-exception';

export type IdleScheduleHandle =
  | { kind: 'idle'; id: number }
  | { kind: 'timeout'; id: ReturnType<typeof setTimeout> };

function wrapIdleUserCallback(callback: () => void): () => void {
  return () =>
    runClientCallbackSafely(callback, {
      tags: { source: 'scheduleIdleCallbackWithFallback' },
      label: 'idle-user-callback',
    });
}

/**
 * Like requestIdleCallback, but uses setTimeout(…, 1) when the browser does not
 * expose requestIdleCallback (e.g. some Safari / WebKit builds).
 */
export function scheduleIdleCallbackWithFallback(
  callback: () => void,
  options?: IdleRequestOptions,
): IdleScheduleHandle {
  const safe = wrapIdleUserCallback(callback);
  if (typeof requestIdleCallback === 'function') {
    const id = requestIdleCallback(safe, options);
    return { kind: 'idle', id };
  }
  return { kind: 'timeout', id: setTimeout(safe, 1) };
}

export function cancelIdleScheduleHandle(handle: IdleScheduleHandle): void {
  if (handle.kind === 'idle') {
    if (typeof cancelIdleCallback === 'function') {
      cancelIdleCallback(handle.id);
    }
    return;
  }
  clearTimeout(handle.id);
}
